package com.bikompanion.ui.mapper

import com.bikompanion.domain.BikeRatingScore

/** Below this many votes, a percentage says more about who happened to vote than about the bike. */
private const val ConfidentVoteCount = 3
private const val GoodBikeThreshold = 70
private const val BadBikeThreshold = 40

/**
 * Turns a raw vote count into a verdict a rider can act on before unlocking a bike.
 *
 * A bare percentage lies at low vote counts — one grumpy rider makes a fine bike read "0%
 * positive" — so the verdict is only stated once there are a few votes behind it.
 */
fun BikeRatingScore.toSummary(): BikeScoreSummaryUiModel {
    val verdict = when {
        totalCount == 0 -> BikeScoreVerdict.NoRatings
        totalCount < ConfidentVoteCount -> BikeScoreVerdict.FewRatings
        percentPositive >= GoodBikeThreshold -> BikeScoreVerdict.LooksGood
        percentPositive <= BadBikeThreshold -> BikeScoreVerdict.HasProblems
        else -> BikeScoreVerdict.Mixed
    }
    val tone = when (verdict) {
        BikeScoreVerdict.LooksGood -> BikeScoreTone.Positive
        BikeScoreVerdict.HasProblems -> BikeScoreTone.Negative
        else -> BikeScoreTone.Neutral
    }
    return BikeScoreSummaryUiModel(
        bikeNumber = key.bikeNumber,
        verdict = verdict,
        tone = tone,
        percentPositive = percentPositive,
        ratingCount = totalCount,
    )
}
